module.exports = __webpack_public_path__ + "img/Poweredby_BroadbandChoices2.7affa0b4.svg";